module.exports = __webpack_public_path__ + "img/Sarah H Stewart.b7ac448f.jpg";